(function($){

	var slickSlider = function() {
		var slideCount = parseInt($('.slide-container__larger').attr('data-count'));
		var slideToStart = Math.floor(Math.random() * slideCount) + 1;
		$('.random-slide').slick({
			autoplay: true,
			nextArrow: '<button type="button" class="slick-next"></button>',
			prevArrow: '<button type="button" class="slick-prev"></button>',
			autoplaySpeed: 5000,
			initialSlide: slideToStart,
		});
		$('.block-slide').slick({
			autoplay: true,
			nextArrow: '<button type="button" class="slick-next"></button>',
			prevArrow: '<button type="button" class="slick-prev"></button>',
			autoplaySpeed: 5000,
		});
	};

	var toggleSubmenu = function() {
		$('.sub-menu .menu-item-has-children').on('click', function(e) {
			$(e.currentTarget).toggleClass('menu-open');
		});
		$('.sub-menu').on('mouseleave', function(e) {
			$(e.currentTarget).find('.menu-item-has-children').removeClass('menu-open');
		});
	};

	var toggleSearchBar = function() {
		$('.search-toggle').on('click', function() {
			$('.upper-menu').toggleClass('search-open');
		});
		$(window).on('scroll', function() {
			$('.upper-menu').removeClass('search-open');
		});
	};

	var galleryImagesModal = function() {
		function prepareSlides(index, img, count) {
			var next;
			var prev;
			if(index == count) {
				next = 0;
			} else {
				next = index + 1;
			}

			if(index == 0) {
				prev = count;
			} else {
				prev = index - 1;
			}

			img.attr('data-prev', prev);
			img.attr('data-next', next);
		}

		$('.gallery-item').on('click', function(e) {
			e.preventDefault();
			var el = $(this);
			var index = el.index();
			var count = el.siblings().length;
			var src = el.find('a').attr('href');
			var modal = document.createElement('div');
			modal.setAttribute('class', 'gallery-item-modal');
			$('body').append(modal);

			var close = document.createElement('span');
			close.setAttribute('class', 'gallery-item-modal__close');
			$('.gallery-item-modal').append(close);
			$('.gallery-item-modal__close').html('x');

			var img = document.createElement('img');
			img.setAttribute('data-count', count);
			img.setAttribute('src', src);
			$('.gallery-item-modal').append(img);

			img = $('.gallery-item-modal img');
			prepareSlides(index, img, count);

			var nextArr = document.createElement('div');
			var prevArrow = document.createElement('div');
			nextArr.setAttribute('class', 'gallery-item-modal__arrow gallery-item-modal__next');
			prevArrow.setAttribute('class', 'gallery-item-modal__arrow gallery-item-modal__prev');
			$('.gallery-item-modal').append(nextArr, prevArrow);
			$('.gallery-item-modal__next').html('>');
			$('.gallery-item-modal__prev').html('<');
		});

		$('body').on('click', '.gallery-item-modal__close', function() {
			$('.gallery-item-modal').fadeOut(500);
			$('.gallery-item-modal').remove();
		});

		$('body').on('click', '.gallery-item-modal__prev', function() {
			var img = $(this).siblings('img');
			var prev = parseInt(img.attr('data-prev'));
			var count = img.attr('data-count');
			var src = $('.gallery-item').eq(prev).find('a').attr('href');
			img.attr('src', src);
			prepareSlides(prev, img, count);
		});

		$('body').on('click', '.gallery-item-modal__next', function() {
			var img = $(this).siblings('img');
			var next = parseInt(img.attr('data-next'));
			var count = img.attr('data-count');
			var src = $('.gallery-item').eq(next).find('a').attr('href');
			img.attr('src', src);
			prepareSlides(next, img, count);
		});
	};

	$(document).ready(function(){
		slickSlider();
		toggleSubmenu();
		toggleSearchBar();
		galleryImagesModal();
	});

})(jQuery);